import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  FilterProps,
  PagedResponse,
} from '../../core/store/general/models/general';
import {
  AssociatedEntities,
  IMyTask,
} from '../../core/store/mytasks/models/MyTasks';
import { createParams } from '../../core/store/utils/utils';

@Injectable({
  providedIn: 'root',
})
export class MyTasksService {
  private baseApiUrl: string = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getMyTasksAll(props: FilterProps): Observable<PagedResponse<IMyTask>> {
    return this.http.get<PagedResponse<IMyTask>>(
      `${this.baseApiUrl}/my-tasks/all${createParams(props)}`,
    );
  }

  getMyTaskById(taskId: string): Observable<IMyTask> {
    return this.http.get<IMyTask>(`${this.baseApiUrl}/my-tasks/${taskId}`);
  }

  getMyTaskAssociatedEntitiesById(
    taskId: string,
  ): Observable<AssociatedEntities> {
    return this.http.get<AssociatedEntities>(
      `${this.baseApiUrl}/my-tasks/${taskId}/associated-entities`,
    );
  }

  updateMyTask(taskId: string, newBody: Partial<IMyTask>): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseApiUrl}/my-tasks/update`, {
      id: taskId,
      ...newBody,
    });
  }
}
